import { get } from 'lodash';
import { twConfig } from 'ui/ds/utils/getConfig';
import { Exclaimation } from 'ui/retail-ds/icons';

interface IProps {
  error: string;
}

const FormError = ({ error }: IProps) => {
  if ((error?.length ?? 0) === 0) {
    return null;
  }

  return (
    <div className="flex gap-1">
      <Exclaimation
        className="w-6 h-6"
        fill={get(twConfig, 'theme.colors.primary[600]')}
        style={{
          flex: '0 0 auto',
        }}
      />
      <p className="text-sm text-primary-600 leading-[160%]">{error}</p>
    </div>
  );
};

export default FormError;
